import BaseAPI from '@/apis/base/baseApi';

export default class CAApi extends BaseAPI {
  apiName = 'CA';
}
